/**
 * ModuleCreatureAmbientState enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ModuleCreatureAmbientState.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum ModuleCreatureAmbientState {
  IDLE =               0,
  READY =              1,
  PAUSE_POISONED =     2,
  DEAD2 =              3,
  DEAD =               4,
  CHOKE =              5,
  WHIRLWIND =          6,
  HORROR =             7,
  DISABLED =           8,
  PRONE_FORCE_PUSHED = 9,
  F2A2 =               10,
  SLEEP =              11,
  PARALYZED =          12,
  PRONE_FORCE_JUMP =   13,
  PRONE_DEAD =         14,
}